import { dynamicElementsUserFeedbackKey } from '@epicuro-next/constants/dynamic-elements';
import { IDynamicItem } from '@epicuro-next/models/platform/dynamic-elements/dynamic-elements';

// tslint:disable-next-line:no-duplicate-string
const id = 'feedback-question-container';

export const userFeedbackPanel: IDynamicItem = {
  id,
  contentTypeId: dynamicElementsUserFeedbackKey,
  styles: {
    style: {
      __multiple__: {
        provider: 'self',
        property: 'panelStyle',
      },
    },
  },
  data: {
    panelStyle: '',
  },
  inputs: {
    contextType: {
      provider: 'self',
      property: 'contextType',
    },
    animationType: {
      provider: 'self',
      property: 'animationType',
    },
    writeEffectEnabled: {
      provider: 'self',
      property: 'writeEffectEnabled',
    },
    writeDelay: {
      provider: 'self',
      property: 'writeDelay',
    },
  },
};

export const merchandisingConfig = {
  arguments: {
    contextType: {
      title: 'ContextType',
      description:
        'Enter the context type (enum IUserFeedbackQuestionContextType)',
      targetElementId: 'feedback-question-container',
      keyInData: 'contextType',
      typeOfValue: 'string',
    },
    animationType: {
      title: 'AnimationType',
      description: 'Specify Animation Type (enum IUserFeedbackAnimationType)',
      targetElementId: 'feedback-question-container',
      keyInData: 'animationType',
      typeOfValue: 'string',
    },
    writeEffectEnabled: {
      title: 'Type Effect Enabled',
      description: 'Specify Type Effect Enabled(true or false)',
      targetElementId: 'feedback-question-container',
      keyInData: 'writeEffectEnabled',
      typeOfValue: 'boolean',
    },
    writeDelay: {
      title: 'Write Delay',
      description: 'Specify Write Delay in ms',
      targetElementId: 'feedback-question-container',
      keyInData: 'writeDelay',
      typeOfValue: 'number',
    },
    panelStyle: {
      title: 'Panel Syle',
      description: 'Specify Css panel style',
      targetElementId: 'feedback-question-container',
      keyInData: 'panelStyle',
      typeOfValue: 'string',
    },
  },
  items: [
    {
      source: 'code',
      key: 'common:user-feedback',
    },
  ],
};
